import { client as r } from "./hitl-client4.js";
const n = (e) => (e.client ?? r).get({
  url: "/conversations",
  ...e
}), a = (e) => (e.client ?? r).post({
  url: "/conversations",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), l = (e) => (e.client ?? r).delete({
  url: "/conversations/{id}",
  ...e
}), s = (e) => (e.client ?? r).get({
  url: "/conversations/{id}",
  ...e
}), c = (e) => (e.client ?? r).post({
  url: "/conversations/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), u = (e) => (e.client ?? r).get({
  url: "/conversations/{id}/history",
  ...e
}), d = (e) => (e.client ?? r).get({
  url: "/conversations/{id}/messages",
  ...e
}), g = (e) => (e.client ?? r).post({
  url: "/messages",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), v = (e) => (e.client ?? r).delete({
  url: "/messages/{id}",
  ...e
}), i = (e) => (e.client ?? r).get({
  url: "/messages/{id}",
  ...e
}), C = (e) => (e.client ?? r).delete({
  url: "/users/me",
  ...e
}), h = (e) => (e.client ?? r).get({
  url: "/users/me",
  ...e
}), m = (e) => (e.client ?? r).post({
  url: "/files",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
}), y = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  url: "/login",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e == null ? void 0 : e.headers
  }
});
export {
  a as createConversation,
  m as createFile,
  g as createMessage,
  l as deleteConversation,
  v as deleteMessage,
  C as deleteUser,
  s as getConversation,
  u as getConversationHistory,
  i as getMessage,
  h as getUser,
  d as listConversationMessages,
  n as listConversations,
  y as login,
  c as updateConversation
};
